/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_RefreshInputs */

const cs_action_refresh = /** @type {(inputs: Action_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit`)
};

const en_action_refresh = /** @type {(inputs: Action_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Action_RefreshInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_refresh = /** @type {((inputs?: Action_RefreshInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_RefreshInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_refresh(inputs)
	return cs_action_refresh(inputs)
});